<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <div class="d-flex justify-content-between">
              <div><strong>Account Settings</strong></div>
            </div>
          </div>
          <b-row>
            <b-col sm="3" class="side-panel">
              <b-nav vertical pills>
                <b-nav-item to="account">Account</b-nav-item>
                <b-nav-item to="password">Password</b-nav-item>
                <!-- <b-nav-item to="email">Email marketing</b-nav-item> -->
              </b-nav>
            </b-col>
            <b-col sm="9">
              <router-view></router-view>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'Settings'
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.side-panel {
  border-right: 1px solid #eee;
}
</style>
